module.exports = __webpack_public_path__ + "img/ticket.d1ca56a3.svg";